// Styles.js
import { styled } from "@mui/material/styles";
import { Box, Paper, TableCell, Button } from "@mui/material";
import {
  TABLE_BODY_ROW_HEIGHT,
  TABLE_COMPACT_HEADER_HEIGHT,
  TABLE_COMPACT_HEADER_PADDING,
  TABLE_HEADER_FONT_SIZE,
} from "../Table/constants.js";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

export const PageRoot = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  width: "100%",
  minHeight: "100vh",
  height: "100vh",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  overflowX: "hidden",
  background: "transparent",
  backgroundColor: "transparent",
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const Card = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  borderRadius: 18,
  boxShadow: "0 10px 35px rgba(0,0,0,0.08)",
  overflow: "hidden",
  border: "1px solid rgba(0,0,0,0.06)",
}));

export const Toolbar = styled(Box)(({ theme }) => ({
  width: "100%",
  alignSelf: "stretch",
  padding: theme.spacing(0, 0, 3, 0),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  marginTop: 0,
  flexWrap: "wrap",
  background: "transparent",
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  minWidth: 340,
  justifyContent: "flex-start",
  alignSelf: "flex-start",
  flexShrink: 0,
}));

export const FiltersWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const FiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textTransform: "none",
  fontWeight: 600,
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: TABLE_HEADER_FONT_SIZE,
  fontWeight: 700,
  color: "rgba(0,0,0,0.70)",
  background: "#F9F9F9",
  borderBottom: 0,
  height: TABLE_COMPACT_HEADER_HEIGHT,
  padding: TABLE_COMPACT_HEADER_PADDING,
  whiteSpace: "nowrap",
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  color: "rgba(0,0,0,0.72)",
  height: TABLE_BODY_ROW_HEIGHT,
  borderBottom: "1px solid rgba(0,0,0,0.06)",
  padding: "0 0 0 16px",
}));

export const Footer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  background: "#fff",
}));

export const TotalText = styled(Box)(({ theme }) => ({
  fontSize: 12,
  color: "#6B7280",
  fontWeight: 400,
}));

export const MainCard__body = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  width: "calc(100% - 10px)",
  maxWidth: "calc(100% - 10px)",
  minWidth: 0,
  borderRadius: "12px",
  background: "transparent",
  backgroundColor: "transparent",
  margin: "0 auto",
  boxSizing: "border-box",
}));

export const CardSplit = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
  height: "auto",
  background: "#fff",
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const TablePane = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  height: "auto",
}));

export const FiltersPane = styled(Box)(({ theme }) => ({
  width: 380,
  flexShrink: 0,
  borderLeft: "1px solid rgba(0,0,0,0.10)",
  background: "#fff",
  display: "flex",
  flexDirection: "column",
  height: "auto",
}));

export const FiltersPaneHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const FiltersChipsRow = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2, 1.5, 2),
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
}));

export const FiltersForm = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  flex: 1,
  overflowY: "auto", // scroll when it grows
}));

export const FiltersRow2 = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(1.5),
}));

export const FiltersActions = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
}));
